<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn
          color="darkColor"
          small
          ref="yes"
          rounded
          class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white"
          @click="confirmDialogConfirmFunction()"
          :disabled="disabelConfirm"
        >
          بله
        </v-btn>
        <v-btn
          small
          rounded
          text
          ref="no"
          class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()"
        >
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">پاسخ</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="1" class="mr-n13">
              <v-btn
                class="mx-2 mt-3 mr-n16"
                fab
                dark
                small
                @click="backToQuestionPage()"
                color="darkColor"
                elevation="0"
              >
                <v-icon dark>mdi-arrow-right mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" class="text-left">
              <v-btn
                @click="showSiteMap()"
                class="ml-2 mt-3"
                outlined
                fab
                x-small
                color="darkColor"
              >
                <v-icon color="darkColor">mdi-clipboard-text-clock mdi-18px</v-icon>
              </v-btn>
              <v-btn
                rounded
                color="darkColor"
                dark
                @click="goToAddAnswerPage(1, 0)"
                class="mt-3 normal-letter-spacing ml-3"
              >
                <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
                افزودن پاسخ
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2 mt-3">
            <v-col cols="12">
              <v-card height="73vh" elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row class="path py-3" v-if="siteMap">
                    <v-col cols="1">
                      <span class="path-title mt-2">پاسخ</span>
                    </v-col>
                    <v-col cols="10" class="mt-2 mb-2">
                      <v-row>
                        <span
                          class="path-chips mr-2"
                          v-for="item in siteMapItems"
                          :key="item.id"
                          @click="goToSiteMapItem(item)"
                        >
                          {{ item.title }}
                        </span>
                      </v-row>
                    </v-col>
                    <v-col cols="1" class="text-left mt-n4">
                      <v-icon @click="closeSiteMap()">mdi-close</v-icon>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="12" v-for="item in allTriageAnswers" :key="item.id">
                      <triage-answer-component
                        :title="item.title"
                        :goTo="
                          item.nextTriageQuestion && item.nextTriageQuestion.chiefComplaint
                            ? item.nextTriageQuestion.chiefComplaint.title
                            : '-'
                        "
                        :hint="item.hint ? item.hint : '-'"
                        :rank="item.rank ? item.rank : 0"
                        :question="
                          item.nextTriageQuestion && item.nextTriageQuestion.chiefComplaint
                            ? item.nextTriageQuestion.title
                            : '-'
                        "
                      >
                        <div slot="action">
                          <v-menu rounded="lg">
                            <template v-slot:activator="{ on: menu, attrs }">
                              <v-tooltip top>
                                <template v-slot:activator="{ on: tooltip }">
                                  <v-icon
                                    color="darkColor"
                                    style="cursor: pointer"
                                    v-bind="attrs"
                                    v-on="{ ...tooltip, ...menu }"
                                  >
                                    mdi-dots-horizontal
                                  </v-icon>
                                </template>
                                <span>بیشتر</span>
                              </v-tooltip>
                            </template>
                            <v-list>
                              <v-list-item
                                dense
                                v-for="actionItems in triageAnsweractionItems"
                                :key="actionItems.id"
                                @click="setActionType(actionItems.type, item)"
                              >
                                <v-list-item-icon>
                                  <v-icon color="iconColor">{{ actionItems.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content class="mr-n6 ml-4">
                                  <v-list-item-title>{{ actionItems.title }}</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </triage-answer-component>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component
      ref="snackRef"
      :snakTimeOut="snakTimeOut"
      :snackColor="snackColor"
      :snackText="snackText"
      :snakIcon="snakIcon"
    ></alert-component>
  </div>
</template>
<script>
  import confirmDialog from '../../components/ConfirmDialog.vue';
  import AlertComponent from '../../components/AlertComponent.vue';
  import TriageAnswerComponent from '../../components/TriageAnswerComponent.vue';

  import snackBar from '@/Mixins/snackBar.js';
  import ShearedMixin from '@/Mixins/Shared.js';
  import ShearedHelper from '@/Helpers/Shared.js';
  import TriageAnswerHelper from '@/Helpers/Triage/TriageAnswerHelper';
  import TriageAnswerMixin from '@/Mixins/Triage/TriageAnswerMixin.js';
  export default {
    name: 'GeneralTriageQuestionManagment',
    title: 'پاسخ',
    inject: ['load', 'tableImg', 'tableTitleImage'],
    components: {
      confirmDialog,
      AlertComponent,
      TriageAnswerComponent,
    },
    mixins: [ShearedMixin, snackBar, TriageAnswerHelper, TriageAnswerMixin, ShearedHelper],
    created() {
      this.$root.$refs.GeneralTriageQuestion = this;
    },
    mounted() {
      this.mounteLoding();
    },
    data() {
      return {};
    },
    methods: {
      mounte: function () {
        let route = this.$route.params.id;
        this.previousQuestionId = Number(route);
        this.previousQuestionTitle = localStorage.getItem('qTitle');
        this.getAllTriageAnswers();
      },
    },
    computed: {
      generalTriageQuestionsFilteredList() {
        return this.allGeneralTriageQuestions.filter((u) => {
          return u.title.toLowerCase().includes(this.searchTitle.toLowerCase());
        });
      },
    },
  };
</script>
<style scoped>
  .confirm-cancel-btn {
    border: solid 1px var(--dark-color);
    padding-top: 13px;
    padding-bottom: 15px;
    color: var(--dark-color);
  }
  .body-card {
    overflow-y: auto !important;
  }
  .path {
    background: var(--background-color) !important;
    border-radius: 12px !important;
  }
  .path-chips {
    background: #d0e6ff;
    border-radius: 30px !important;
    padding-left: 22px !important;
    padding-right: 22px !important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  .path-title {
    font-weight: 600;
    font-size: 15px;
    color: black;
  }
  @media only screen and (min-width: 1280px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1366px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 98.5% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1536px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 1vh !important;
    }
  }
</style>
